<template>
  <main>
    <div class="container">
      <div class="pricing-container">
        <h1 class="heading-primary">Compare our plans</h1>
        <p class="description">
          Transparent, affordable pricing on the data and tools retail investors
          need.<br><br>
        
        <span style="font-size:1.6rem;">
          Start with a free plan (no credit card required) and then upgrade to our Premium subscription when ready.<br>
          You can also purchase Investor Passes using our in-app currency called Playdough.<br>  
          You can buy Playdough seperately or you can earn it in the app by trading, playing games and answer/asking questions that help others.<br>
          Basic Investor Passes remove usage limits on the Free plan for the duration of the pass.  <br>Premium Investor Passes remove usage limits and 
          give you access to all premium features for the duration of the pass.<br>
          Investor Passes come in 1, 14 and 30 day durations.
        </span>
        </p>
        <div class="pricing-grid" v-if="!isMobile()">
          <div class="grid-header">
             <div class="toggle" style="margin-bottom: 43px;">
                <button :class="annual ? 'tb' : 'selected tb'" @click="monthlyHandler">
                  Monthly
                </button>
                <button :class="annual ? 'selected tb' : 'tb'" @click="annualHandler">
                  Annual
                </button>
              </div>
            <div class="plan">
              <h3>Free</h3>
              <p class="pricing">$0</p>
              <button @click="goToApp">Get Started</button>
              <div class="spacer"></div>
            </div>
            <div class="plan">
              <h3>Premium</h3>
              <p class="pricing">{{ annual ? "$69.50" : "$6.95" }}</p>
              <button @click="goToApp">Get Started</button>
              <div class="spacer"></div>
            </div>
            <div class="plan">
              <h3>Investor Pass</h3>
              <p class="pricing">Playdough</p>
              <button @click="goToApp">Get Started</button>
              <div class="toggle" style="margin-top:3px;margin-left: auto;margin-right:auto;">
                <button :class="premium ? 'tb' : 'selected tb'" @click="basicHandler" >
                  Basic
                </button>
                <button :class="premium ? 'selected tb' : 'tb'" @click="premiumHandler" >
                  Premium
                </button>
              </div>
            </div>
          </div>
          <div class="grid-subheader" style="padding-top:0px;">
            <h2>Core functionality</h2>
            
          </div>
          <p>Social feeds</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Groups</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Direct Messaging</p>
          <p class='free__direct-messaging'>Max of 4 people</p>
          <i class="pi pi-check"></i>
          <p v-if="!premium" class='free__direct-messaging'>Max of 4 people</p>
          <i v-else class='pi pi-check'></i>
          <p>News/events</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Paper Portfolios</p>
          <p class='free__direct-messaging'>2 Trading</p>
          <p class='free__direct-messaging'>Unlimited</p>
          <p v-if="!premium" class='free__direct-messaging'>2 Trading</p>
          <p v-else class='free__direct-messaging'>Unlimited</p>
          <p>Market screener</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Unlimited watchlists</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Flexible charting</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Note library</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Index data</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Currency data</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Futures data</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <p>Rates data</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <p>Custom alerts</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <p>Earnings calendar</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <p>Portfolio cash flow</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <p>Dividends calendar</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <div class="grid-subheader">
            <h2>Company data</h2>
          </div>
          <p>Price data</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Financial data</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Fundamental data</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Analyst estimates</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Insider transactions</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Advanced charting</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Dividend history</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Company news/events</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Company filings</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <p>Shareholder information</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <p>Granular trade data</p>
          <i class="pi pi-times"></i>
          <i class="pi pi-check"></i>
          <i v-if="!premium" class="pi pi-times"></i>
          <i v-else class="pi pi-check"></i>
          <div class="grid-subheader">
            <h2>Fund data</h2>
          </div>
          <p>Price data</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Allocation data</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Relative performance</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Holdings data</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Advanced charting</p>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <i class="pi pi-check"></i>
          <p>Dividend history</p>
          <i class="pi pi-check last"></i>
          <i class="pi pi-check last"></i>
          <i class="pi pi-check last"></i>
          <div class="grid-subheader">
            <h2>Usage Limits</h2>
          </div>
          <p>Trading</p>
          <p class='free__direct-messaging'>3 Trades per day</p>
          <p class='free__direct-messaging'>No Limits</p>
          <p v-if="!premium" class='free__direct-messaging'>3 Trades per day</p>
          <p v-else class='free__direct-messaging'>No Limits</p>
          <p>Research Sessions</p>
          <p class='free__direct-messaging'>5 sessions in 30 days</p>
          <p class='free__direct-messaging'>No Limits</p>
          <p v-if="!premium" class='free__direct-messaging'>5 sessions in 30 days</p>
          <p v-else class='free__direct-messaging'>No Limits</p>
          
        </div>
        <div class="pricing-grid" v-else>
          <div class="grid-header">
            <div class="toggle">
              <button :class="currentPlan === 0 ? 'selected' : ''" @click="currentPlanHandler(0)">
                Free
              </button>
              <button :class="currentPlan === 1 ? 'selected' : ''" @click="currentPlanHandler(1)">
                Premium
              </button>
              <button :class="currentPlan === 2 ? 'selected' : ''" @click="currentPlanHandler(2)">
                Investor Pass
              </button>
            </div>
            <div class="plan">
              <h3 v-if="currentPlan != 2">Monthly/Annual</h3>
              <p class="pricing" v-if="currentPlan === 0">$0</p>
              <p class="pricing" v-else-if="currentPlan === 1">$6.95/$69.50</p>
              <p class="pricing" v-else-if="currentPlan === 2">Playdough</p>
             
              <button @click="goToApp">Get Started</button>
              <div v-if="currentPlan === 2" class="toggle" style="margin-top:3px;margin-left: auto;margin-right:auto;">
                <button :class="premium ? 'tb' : 'selected tb'" @click="basicHandler" >
                  Basic
                </button>
                <button :class="premium ? 'selected tb' : 'tb'" @click="premiumHandler" >
                  Premium
                </button>
              </div>
            </div>
          </div>
          <div class="grid-subheader" style="padding-top:0;">
            <h2>Core functionality</h2>
          </div>
          <p>Social feeds</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Groups</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Direct Messaging</p>
          <p class='free__direct-messaging' v-if="currentPlan === 0">Max of 4 people</p>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <p class='free__direct-messaging' v-else-if="currentPlan === 2 && !premium">Max of 4 people</p>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>News/events</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Paper Portfolios</p>
          <p class='free__direct-messaging' v-if="currentPlan === 0">2 Trading</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 1">Unlimited</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 2 && !premium">2 Trading</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 2">Unlimited</p>
          <p>Market screener</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Unlimited watchlists</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Flexible charting</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Note library</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Index data</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Currency data</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Futures data</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Rates data</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
         <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Custom alerts</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
         <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Earnings calendar</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Portfolio cash flow</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Dividends calendar</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <div class="grid-subheader">
            <h2>Company data</h2>
          </div>
          <p>Price data</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Financial data</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Fundamental data</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Analyst estimates</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Insider transactions</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Advanced charting</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Dividend history</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Company news/events</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Company filings</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Shareholder information</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
         <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Granular trade data</p>
          <i class="pi pi-times" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-times" v-else-if="currentPlan === 2 && !premium"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <div class="grid-subheader">
            <h2>Fund data</h2>
          </div>
          <p>Price data</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Allocation data</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Relative performance</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Holdings data</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Advanced charting</p>
          <i class="pi pi-check" v-if="currentPlan === 0"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check" v-else-if="currentPlan === 2"></i>
          <p>Dividend history</p>
          <i class="pi pi-check last" v-if="currentPlan === 0"></i>
          <i class="pi pi-check last" v-else-if="currentPlan === 1"></i>
          <i class="pi pi-check last" v-else-if="currentPlan === 2"></i>
          <div class="grid-subheader">
            <h2>Usage Limits</h2>
          </div>
          <p>Trading</p>
          <p class='free__direct-messaging' v-if="currentPlan === 0">3 Trades per day</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 1">Unlimited</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 2 && !premium">3 Trades per day</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 2 ">Unlimited</p>
          <p>Research Sessions</p>
          <p class='free__direct-messaging' v-if="currentPlan === 0">5 within 30 days</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 1">Unlimited</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 2 && !premium">5 within 30 days</p>
          <p class='free__direct-messaging' v-else-if="currentPlan === 2 ">Unlimited</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import "primeicons/primeicons.css";
import { SIGNUP_URL, VUE_APP_REDIRECT_URL } from "../config";

export default {
  data() {
    return {
      annual:false,
      isLoggedIn: false,

      currentPlan: 1,
      premium:false,
    };
  },

  mounted() {
    if (this.$route.query.loggedIn) {
      this.isLoggedIn = true;
    }
  },

  methods: {
    isMobile() {
      let check = false;

      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);//eslint-disable-line
    
      return check;
    },

    monthlyHandler() {
      this.annual = false;
    },

    basicHandler() {
      this.premium = false;
    },


    annualHandler() {
      this.annual = true;
    },

    premiumHandler() {
      this.premium = true;
    },

    currentPlanHandler(num) {
      this.currentPlan = num;
    },

    goToApp() {
      if (this.isLoggedIn) {
        if (this.$route.query.fromBilling) {
          window.close();
        } else {
          window.location = VUE_APP_REDIRECT_URL;
        }
      } else {
        window.location.href = SIGNUP_URL;
      }
    },

    
  },
};
</script>

<style scoped>

.toggle .tb {
  padding: .5rem 1rem;
  font-size: 16px !important;

}

.toggle .tb:hover:not(.selected) {
  color: #333;
  background-color: #d1d2d3;
}
.toggle .selected.tb:hover  {
  color: #333;
}

.pricing-container {
  padding: 18rem 12rem;
}

.description {
  margin-bottom: 6.4rem;
  line-height: 3.5rem;
}

.spacer {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: end;
  justify-self: start;
  min-height:44px;
}


.toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: end;
  justify-self: start;
  
}

.toggle h4 {
  font-size: 1.8rem;
  font-weight: 400;
  margin-right: 0.8rem;
}

.toggle h4:last-child {
  margin-left: 0.8rem;
  margin-right: 0;
}

.pricing-grid,
.grid-header {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 2rem;
}

.grid-subheader,
.grid-header {
  grid-column: 1 / 5;
}

.plan {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.plan h3 {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 1.2rem;
  text-align: center;
}

.pricing-grid .plan p {
  font-size: 2.4rem;
  font-weight: 400;
  margin-bottom: 1.2rem;
  color: #999;
}

.plan button {
  padding: 1.2rem 2.4rem;
  border-radius: 8px;
  border: 1px solid #693bf5;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  font-size: 1.6rem;
  font-family: inherit;
}

.plan button:hover {
  background-color: #693bf5;
  color: #fff;
}

.grid-subheader {
  padding-top: 2.4rem;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid #d1d2d3;
}

.grid-subheader h2 {
  font-size: 2.8rem;
  font-weight: 500;
  color: #333;
}

.pricing-grid p {
  font-size: 1.6rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 1.2rem;
  align-self: center;
  line-height: 1.2;
}

.pi-check,
.pi-times {
  font-size: 2.4rem;
  color: #3c9;
  align-self: center;
  justify-self: center;
}

.pi-times {
  color: #d1d2d3;
}

.toggle {
  background-color: #d1d2d3;
  padding: 0.6rem;
  border-radius: 8px;
}

.toggle button {
  margin-right: 8px;
  padding: 1rem 2rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  background-color: transparent;
}

.toggle button:last-child {
  margin-right: 0;
}

.toggle button.selected {
  background-color: #f2f4fa;
}

.pricing-grid .free__direct-messaging {
  text-align: center;
  margin-bottom: 0px;
}

/* **************************** */
/* BELOW 1360px (Small desktop/laptop) */
/* **************************** */
@media (max-width: 85em) {
  .heading-primary {
    font-size: 6rem;
  }
}

/* **************************** */
/* BELOW 976px (landscape tablets) */
/* **************************** */
@media (max-width: 61em) {
  .heading-primary {
    font-size: 5.6rem;
  }
}

/* **************************** */
/* BELOW 800px (tablet) */
/* **************************** */
@media (max-width: 50em) {
  .pricing-container {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}

/* **************************** */
/* BELOW 592px (mobile) */
/* **************************** */
@media (max-width: 37em) {
  .pricing-container {
    padding-left: 2.4rem;
    padding-right: 2.4rem;
  }

  .heading-primary {
    font-size: 5rem;
  }

  .pricing-grid,
  .grid-header {
    grid-template-columns: 1fr;
  }

  .pricing-grid .free__direct-messaging {
    grid-column: auto;
    text-align: right;
    margin-bottom: 1.2rem;
  }

  .pi-check,
  .pi-times {
    text-align: right;
  }
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
  .heading-primary {
    font-size: 4.4rem;
    text-align: center;
    line-height: 1.2;
  }

  .description {
    text-align: center;
  }

  .pricing-grid,
  .grid-header {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }

  .toggle {
    grid-column: 1 / 3;
    justify-self: center;
    margin-bottom: 2.4rem;
  }

  .pricing-grid p {
    grid-column: 1 / 4;
    font-size: 1.8rem;
  }

  .grid-subheader {
    margin-top: 3.2rem;
    margin-bottom: 1.6rem;
  }

  .pi-check,
  .pi-times {
    width: 100%;
    justify-self: center;
    margin-bottom: 1.6rem;
  }

  .pi-check.last {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .pricing-grid .plan p {
    font-size: 2.2rem;
  }
}

/* **************************** */
/* BELOW 432px (mobile) */
/* **************************** */
@media (max-width: 27em) {
  .pricing-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
